import * as React from "react";

const Logo = (props) => (
  <svg
    max-width={51}
    // height={42}
    viewBox="0 0 51 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3452 13.0722H22.4V21.3728C20.1254 23.9242 16.8618 25.2 12.6093 25.2C9.01603 25.2 6.01618 24.0071 3.60971 21.6213C1.20324 19.2355 0 16.2532 0 12.6745C0 9.09585 1.21972 6.09703 3.65916 3.6781C6.13156 1.22603 9.11493 0 12.6093 0C16.1036 0 19.0045 1.01065 21.3121 3.03195L19.1364 6.16331C17.4552 4.73846 15.3948 4.02603 12.9554 4.02603C10.483 4.02603 8.40617 4.83786 6.72494 6.46153C5.07667 8.05206 4.25254 10.1231 4.25254 12.6745C4.25254 15.226 5.0437 17.297 6.62604 18.8876C8.24135 20.445 10.2358 21.2236 12.6093 21.2236C14.9168 21.2236 16.8288 20.7266 18.3452 19.7325V13.0722Z"
      fill="#161C24"
    />
    <line
      x1={27.1001}
      y1={2.18557e-8}
      x2={27.1001}
      y2={16.8}
      stroke="#161C24"
    />
    <line x1={27.1001} y1={16.8} x2={27.1001} y2={33.6} stroke="#4295E4" />
    <path
      d="M41.4197 42C37.4866 42 33.9468 40.775 30.8003 38.325L33.2913 34.3219C36.0881 36.4656 38.8413 37.5375 41.5508 37.5375C42.687 37.5375 43.5829 37.275 44.2384 36.75C44.9376 36.1812 45.2872 35.4813 45.2872 34.65C45.2872 33.425 43.6703 32.3313 40.4364 31.3688C40.349 31.325 40.2398 31.2813 40.1086 31.2375C40.0212 31.1938 39.9557 31.1719 39.912 31.1719C34.8427 29.8156 32.308 27.5188 32.308 24.2813C32.308 22.0063 33.1602 20.1906 34.8645 18.8344C36.6126 17.4781 38.9069 16.8 41.7474 16.8C44.5443 16.8 47.2101 17.6313 49.7448 19.2938L47.8438 23.1C45.8772 21.7875 43.714 21.1313 41.3541 21.1313C38.601 21.1313 37.2244 22.0063 37.2244 23.7563C37.2244 24.5 37.4866 25.0469 38.011 25.3969C38.5791 25.7031 39.4968 26.0094 40.7642 26.3156C42.687 26.8406 44.304 27.3656 45.615 27.8906C46.489 28.2844 47.2538 28.7 47.9093 29.1375C49.57 30.275 50.4003 32.0031 50.4003 34.3219C50.4003 36.5969 49.5481 38.4562 47.8438 39.9C46.1831 41.3 44.0418 42 41.4197 42Z"
      fill="#4295E4"
    />
  </svg>
)
export default Logo;
